<template>
  <div v-frag class="text-center">
    <v-overlay :value="loader" z-index="9999">
      <v-progress-circular indeterminate size="64"> </v-progress-circular>
      <br />
      Cargando...<br />
      Este proceso puede durar unos segundos....
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "Loader",
  computed: {
    loader() {
      return this.$store.getters.loader;
    }
  },
  data: () => ({
    overlay: false
  })
};
</script>
